<template>
  <div class="not-found">
    <van-dialog v-model="showDialog" class="dialog" :showConfirmButton="false">
      <div class="not-found-content">
        <img src="@/assets/404.svg" alt="404" class="not-found-img" />
        <div class="not-found-text">
          <h2>页面不存在</h2>
          <p>抱歉，您访问的页面不存在或已被移除</p>
        </div>
        <van-button 
          type="primary" 
          size="large" 
          class="back-btn"
          @click="goBack"
        >
          返回上一页
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog, Button } from "vant";
export default {
  name: "notData",
  data() {
    return {
      showDialog: true,
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.not-found {
  .dialog {
    width: 80%;
    max-width: 300px;
    border-radius: 12px;
    overflow: hidden;
  }
  
  .not-found-content {
    padding: 20px;
    text-align: center;
    
    .not-found-img {
      width: 120px;
      height: 120px;
      margin-bottom: 20px;
    }
    
    .not-found-text {
      margin-bottom: 20px;
      
      h2 {
        font-size: 18px;
        color: #323233;
        margin-bottom: 8px;
      }
      
      p {
        font-size: 14px;
        color: #969799;
        line-height: 1.5;
      }
    }
    
    .back-btn {
      width: 100%;
      border-radius: 4px;
      background: #1989fa;
      border: none;
    }
  }
}
</style>
